import { Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutSidebarService } from '../../../shared/services/layout-sidebar.service';
import { ThemeService } from '../../../shared/services/theme.service';
import { NotificationDropdownComponent } from '../components/header/notification-dropdown/notification-dropdown.component';
import { UserDropdownComponent } from '../components/header/user-dropdown/user-dropdown.component';

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    RouterModule,
    NotificationDropdownComponent,
    UserDropdownComponent,
  ],
  templateUrl: './app-header.component.html',
})
export class AppHeaderComponent {
  isApplicationMenuOpen = false;
  readonly isExpanded;
  readonly isMobileOpen;
  readonly isHovered;
  readonly isFullscreen;
  readonly isFullscreenOpen;
  readonly theme$;

  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  constructor(
    public sidebarService: LayoutSidebarService,
    private themeService: ThemeService) {
    this.isExpanded = this.sidebarService.isExpanded;
    this.isMobileOpen = this.sidebarService.isMobileOpen;
    this.isHovered = this.sidebarService.isHovered;
    this.isFullscreen = this.sidebarService.isFullscreen;
    this.isFullscreenOpen = this.sidebarService.isFullscreenOpen;
    this.theme$ = this.themeService.theme$;
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }

  handleToggle() {
    if(this.isFullscreen()){
      this.sidebarService.toggleFullscreenOpen();
    } else {
      if (window.innerWidth >= 1280) {
        this.sidebarService.toggleExpanded();
      } else {
        this.sidebarService.toggleMobileOpen();
      }
    }
  }

  toggleApplicationMenu() {
    this.isApplicationMenuOpen = !this.isApplicationMenuOpen;
  }

  ngAfterViewInit() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = (event: KeyboardEvent) => {
    if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
      event.preventDefault();
      this.searchInput?.nativeElement.focus();
    }
  };

  onSidebarMouseEnter() {
    if (!this.isExpanded()) {
      this.sidebarService.setHovered(true);
    }
  }

  sideMenuToggle() {
    if (window.innerWidth >= 1280) {
      this.sidebarService.toggleExpanded();
    } else {
      this.sidebarService.toggleMobileOpen();
    }
  }
}
